import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "m-feed-compute" }
const _hoisted_2 = { class: "m-feed-compute-remove" }
const _hoisted_3 = { class: "m-flex" }
const _hoisted_4 = { class: "m-form-item m-mr-16" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "m-form-item-label" }, "貓飼料熱量", -1)
const _hoisted_6 = { class: "m-form-item-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "m-mr-15 m-ml-15" }, "/", -1)
const _hoisted_8 = { class: "m-form-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "m-form-item-label" }, "一日所需", -1)
const _hoisted_10 = { class: "m-form-item-content" }
const _hoisted_11 = { class: "kcal-result" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 更多 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" g ")
const _hoisted_17 = { class: "m-flex" }
const _hoisted_18 = { class: "m-form-item m-mr-16" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "m-form-item-label" }, "每日分幾餐", -1)
const _hoisted_20 = { class: "m-form-item-content" }
const _hoisted_21 = { class: "m-form-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "m-form-item-label" }, "每餐所需", -1)
const _hoisted_23 = { class: "m-form-item-content" }
const _hoisted_24 = { class: "kcal-result" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 更多 ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" g ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_outlined = _resolveComponent("close-outlined")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!

  return (_openBlock(), _createBlock(_component_a_col, {
    class: "m-mb-16",
    span: 24,
    lg: 12
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
          }, [
            _createVNode(_component_close_outlined)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_input_number, {
                value: _ctx.feedKcal,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.feedKcal) = $event)),
                class: "m-w-100",
                size: "large",
                placeholder: "kcal",
                onFocus: _ctx.handleFocus,
                type: 'number',
                min: 0,
                max: 9999
              }, null, 8, ["value", "onFocus"]),
              _hoisted_7,
              _createVNode(_component_a_select, {
                class: "m-w-100",
                value: _ctx.feedKcalUnit,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.feedKcalUnit) = $event)),
                size: "large"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kcalUnitOption, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.value,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.total?.[0] || _ctx.total[0] === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.total[0]), 1))
                  : _createCommentVNode("", true),
                (_ctx.total?.[1])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "~"))
                  : _createCommentVNode("", true),
                (_ctx.total?.[1])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      (_ctx.total[1] === '*')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_15
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.total[1]), 1)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_16
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_a_input_number, {
                class: "count-input",
                value: _ctx.count,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.count) = $event)),
                size: "large",
                placeholder: "每日分幾餐",
                onFocus: _ctx.handleFocus,
                type: 'number',
                min: 1,
                max: 100
              }, null, 8, ["value", "onFocus"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                (_ctx.meal?.[0] || _ctx.meal[0] === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.meal[0]), 1))
                  : _createCommentVNode("", true),
                (_ctx.meal?.[1])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "~"))
                  : _createCommentVNode("", true),
                (_ctx.meal?.[1])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                      (_ctx.meal?.[1] === '*')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_28
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.meal[1]), 1)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_29
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}